import React, { useMemo } from 'react';
import './style.scss';
import clsx from 'clsx';
import MenuButton from '../../appHeader/menuButton/MenuButton';

interface DialogProps {
  opened: boolean;
  onClose?: () => any;
  children: React.ReactNode;
  className?: string;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
  centered?: boolean;
  noCloseOnMobile?: boolean;
}

const Dialog = ({
  opened,
  onClose,
  children,
  className,
  maxWidth,
  fullWidth = false,
  centered = false,
  noCloseOnMobile = false
}: DialogProps) => {
  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const maxWidthClassName = useMemo<string | undefined>(() => {
    if (maxWidth) return `dialog-${maxWidth}`;
    return undefined;
  }, [maxWidth]);

  return (
    <div
      className={clsx('dialog-wrapper', !opened && 'dialog-wrapper-hidden')}
      onClick={onClose}
    >
      <div
        className={clsx(
          'dialog',
          maxWidthClassName,
          centered && 'dialog-centered',
          fullWidth && 'dialog-fullwidth',
          className
        )}
        onClick={(e) => handleClick(e)}
      >
        {onClose && (
          <MenuButton
            active={true}
            onClick={onClose}
            activeColor='#FFF'
            className={clsx(
              'close-button',
              noCloseOnMobile && 'close-button-mobile-hidden'
            )}
          />
        )}
        {children}
      </div>
    </div>
  );
};

export default Dialog;
